import { render, staticRenderFns } from "./click_logs_button.vue?vue&type=template&id=5369cfa4&lang=pug&"
import script from "./click_logs_button.vue?vue&type=script&lang=js&"
export * from "./click_logs_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports